import { render, staticRenderFns } from "./CustomerInsuranceLiability.vue?vue&type=template&id=7c5b5a84"
import script from "./CustomerInsuranceLiability.vue?vue&type=script&lang=js"
export * from "./CustomerInsuranceLiability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports